import { createRouter, createWebHistory } from 'vue-router'
import NotFoundComponent from '../views/NotFoundComponent.vue'
import TaskList from '../views/TaskList.vue'
import TaskLayout from '../views/task/Layout.vue'
import TaskDetails from '../views/task/Details.vue'
import TaskEdit from '../views/task/Edit.vue'
import TaskDelete from '../views/task/Delete.vue'
import About from '../views/About.vue'

const routes = [
  {
    path: '/:catchAll(.*)',
    component: NotFoundComponent
  },
  {
    path: '/',
    name: 'TaskList',
    component: TaskList,
    props: route => ({ page: parseInt(route.query.page) || 1 })
  },
  {
    path: '/about',
    name: 'About',
    component: About
  },
  {
    path: '/tasks/:id',
    name: 'TaskLayout',
    props: true,
    component: TaskLayout,
    children: [
      {
        path: '',
        name: 'TaskDetails',
        component: TaskDetails
      },
      {
        path: 'edit',
        name: 'TaskEdit',
        component: TaskEdit
      },
      {
        path: 'delete',
        name: 'TaskDelete',
        component: TaskDelete
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
